<template>
  <div class="mapFilterBox">
    <vue-awesomplete @selectcomplete="selectItem()" v-model="value" :placeholder="'Hier suchen…'" :setting="{ autoFirst: true, list: this.$parent.mergedFilteredData , data: function (item, input) { return { label: item.title, value: item['.key'] } } }" ref="skills"></vue-awesomplete>
    <button class="btn--subtile btn--icon" v-bind:class="{ selected: filter }" style="z-index:3; margin-right: 10px;" @click="toggleFilter()"><svgicon icon="filter" width="32" height="32" color="#000000"></svgicon><span class="count" v-if="filterCount">{{filterCount}}</span></button>
    <button class="btn--subtile btn--icon" style="z-index:2" v-bind:class="{ selected: history }" @click="toggleHistory()"><svgicon icon="history" width="32" height="32" color="#000000"></svgicon></button>
    <div class="filter" v-if="filter">
      Priorität:
      <select v-model="fPriority" @change="setFilter()">
        <option value="false">kein Filter</option>
        <option value="3">Priorität 3</option>
        <option value="2">Priorität 2</option>
        <option value="1">Priorität 1</option>
      </select>
      <br />
      Typ:
      <select v-model="fType" @change="setFilter()">
        <option value="false">kein Filter</option>
        <option value="handshake">Absprache</option>
        <option value="code">Code</option>
        <option value="lab">Entwicklung</option>
        <option value="error">Fehler</option>
        <option value="gutachten">Gutachten</option>
        <option value="lightbulb">Idee</option>
        <option value="statistics">Kennzahl</option>
        <option value="book">Literatur</option>
        <option value="note">Notiz</option>
        <option value="person">Persona</option>
        <option value="present">Präsentatio</option>
        <option value="search">Research</option>
        <option value="fire">Trend</option>
        <option value="warning">Warnung</option>
        <option value="target">Ziel</option>
        <option value="quote">Zitat</option>
      </select>
      <br />
      Projekt:
      <select v-model="fProject" @change="setFilter()">
        <option value="false">kein Filter</option>
        <option v-for="(project, index) in projects" v-bind:key="index" :value="project['.key']">{{project.title}}</option>
      </select>
      <br />
      Tag:
      <select v-model="fTag" @change="setFilter()">
        <option value="false">kein Filter</option>
        <option v-for="(tag, index) in tags" v-bind:key="index" :value="tag['.key']">{{tag.title}}</option>
      </select>
      <button class="btn--subtile" @click="removeAll()" style="margin-bottom: 0">alle entfernen</button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import VueAwesomplete from 'vue-awesomplete'
import AwesompleteCss from 'awesomplete/awesomplete.css' // eslint-disable-line

var db = firebase.database()
var projectsRef = db.ref('projects')
var tagsRef = db.ref('tags')

export default {
  name: 'MapFilterBox',
  components: {
    VueAwesomplete
  },
  data () {
    return {
      value: null,
      searchItem: null,
      fPriority: false,
      fProject: this.project,
      fTag: this.tag,
      fType: false,
      filter: false
    }
  },
  updated () {
    if (this.$refs.skills) {
      this.$refs.skills.list(this.$parent.mergedFilteredData)
    }
  },
  props: ['history', 'items', 'project', 'priority', 'tag', 'type'],
  computed: {
    filterCount: function () {
      let count = false
      if (this.fPriority) { count = count + 1 }
      if (this.fProject) { count = count + 1 }
      if (this.fTag) { count = count + 1 }
      if (this.fType) { count = count + 1 }
      return count
    }
  },
  methods: {
    toggleHistory () {
      this.$emit('toggleHistory')
    },
    toggleFilter () {
      if (this.filter) {
        this.filter = false
      } else {
        this.filter = true
      }
    },
    removeAll () {
      let filters = { priority: false, project: false, tag: false, type: false }
      this.$emit('setFilter', filters)
      this.fPriority = false
      this.fProject = false
      this.fTag = false
      this.fType = false
      this.toggleFilter()
    },
    setFilter: function () {
      if (this.fPriority === 'false') {
        this.fPriority = false
      }
      if (this.fType === 'false') {
        this.fType = false
      }
      let filters = { priority: this.fPriority, project: this.fProject, tag: this.fTag, type: this.fType }
      this.$emit('setFilter', filters)
      this.toggleFilter()
    },
    selectItem () {
      this.$nextTick(() => {
        this.$emit('searchComplete', this.value)
        this.$refs.skills.internalValue = null
        document.activeElement.blur()
      })
    }
  },
  firebase () {
    return {
      projects: projectsRef,
      tags: tagsRef
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  .mapFilterBox {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 10;
    line-height: 48px;
    font-size: 17px;
  }

  .mapFilterBox .awesomplete input {
    display: inline-block;
    width: 180px !important;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.3);
    border: none;
    height: 46px;
    z-index: 10;
    position: relative;
  }

  .mapFilterBox > button {
    position: relative;
    z-index: 1;
  }

  .mapFilterBox .count {
    display: inline-block;
    position: absolute;
    z-index: 20;
    top: -10px;
    right: -10px;
    background: $color-action;
    border: 1px solid #fff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    border-radius: 50%;
  }

  .mapFilterBox .filter {
    position: absolute;
    // left: 320px;
    left: 99px;
    box-sizing: border-box;
    padding: 10px 20px;
    width: 220px;
    top: 55px;
    font-weight: bold;
    font-size: 15px;
    text-transform: uppercase;
    // color: rgba($color-grey,0.6);
    color: $color-highlight;
    color: rgba($color-action, 0.3);
    letter-spacing: 1px;
    font-weight: 700;
    font-family: 'Dosis', sans-serif;
    background: rgba(#fff, 0.94);
    box-shadow: 0 2px 5px 0 rgba($color-text,0.3);
    &:before {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
      content: " ";
      position: absolute;
      left: 50%;
      margin-left: -5px;
      top: -6px;
    }
  }

  .mapFilterBox .awesomplete {
    margin-right: 10px;
  }

  .mapFilterBox .awesomplete > ul {
    z-index: 5;
    border: none;
    li {
      background: rgba(darken($color-action,7.5%),0.9);
      color: #fff;
      padding-left: 15px;
      padding-right: 0px;
      line-height: 38px;
      &:after {
        content: " \00BB";
        opacity: 0.5;
      }
    }
    li[aria-selected="true"] {
      // background: rgba($color-action, 0.1) !important;
      background: rgba($color-action,0.9) !important;
      color: #fff;
    }
  }

  .awesomplete > ul:before {
    background: $color-action;
    display: none;
  }

  .awesomplete > ul {
    margin: 0;
  }

  .awesomplete mark {
    // background: rgba($color-highlight, 0.7) !important;
    background: rgba(#fff, 0.15) !important;
    color: #fff;
  }

  .mapFilterBox > button {
    margin-bottom: 0;
    background: rgba(#fff,0.9) !important;
    color: $color-action !important;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.3);

    &.selected {
      background: $color-action !important;
      color: #fff !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/MapFilterBox.vue